(() => {
  'use strict';
  if (window.EasXTracking || window.Shopify?.designMode) return;
  const pixelId = 'ridkz', eventId = 'tw-ridkz-ridl9';
  const pendingKey = 'eas-x-pending-v1', sentKey = 'eas-x-sent-v1';
  const day = 86400000;
  let configured = false, loadingPrivacy = false, timer = null, ticks = 0;
  const read = (type, key, fallback) => {
    try { return JSON.parse(window[type].getItem(key)) || fallback; } catch { return fallback; }
  };
  const write = (type, key, value) => {
    try { window[type].setItem(key, JSON.stringify(value)); } catch {}
  };
  const status = value => { document.documentElement.dataset.easXPixel = value; };
  const money = value => value !== null && value !== undefined && String(value).trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 ? Number(value) : null;
  const valid = row => row && /^eas_(order_\d{5,20}|ss_[A-Za-z0-9-]{1,30})$/.test(row.id)
    && /^[A-Z]{3}$/.test(row.currency) && money(row.value) !== null
    && Number.isFinite(row.createdAt) && row.createdAt <= Date.now() && Date.now() - row.createdAt < day;
  const permitted = () => {
    try { return window.Shopify?.customerPrivacy?.marketingAllowed() === true && window.Shopify.customerPrivacy.saleOfDataAllowed() === true; } catch { return false; }
  };
  let pending = read('sessionStorage', pendingKey, []);
  pending = Array.isArray(pending) ? pending.filter(valid).slice(-20) : [];
  let sent = read('localStorage', sentKey, {});
  sent = sent && typeof sent === 'object' && !Array.isArray(sent) ? Object.fromEntries(Object.entries(sent).filter(([key, time]) => /^eas_(order_\d{5,20}|ss_[A-Za-z0-9-]{1,30})$/.test(key) && Number.isFinite(time) && time <= Date.now() && Date.now() - time < 30 * day).slice(-200)) : {};
  function configure() {
    if (configured || !permitted()) return;
    if (!window.twq) {
      const q = window.twq = function () { q.exe ? q.exe.apply(q, arguments) : q.queue.push(arguments); };
      q.version = '1.1'; q.queue = [];
      const script = document.createElement('script');
      script.async = true; script.src = 'https://static.ads-twitter.com/uwt.js';
      script.addEventListener('load', flush, { once: true });
      script.addEventListener('error', () => status('blocked-or-unavailable'), { once: true });
      document.head.appendChild(script);
    }
    window.twq('config', pixelId);
    configured = true;
    status('base-configured');
  }
  function flush() {
    if (!permitted()) { status('waiting-for-consent'); return; }
    configure();
    if (typeof window.twq?.exe !== 'function') return;
    pending = pending.filter(valid);
    for (const row of pending) {
      if (sent[row.id]) continue;
      try {
        window.twq('event', eventId, { value: row.value, currency: row.currency, conversion_id: row.id });
        sent[row.id] = Date.now();
        write('localStorage', sentKey, sent);
        status('sales-event-dispatched');
      } catch {}
    }
    pending = pending.filter(row => !sent[row.id]);
    write('sessionStorage', pendingKey, pending);
    if (!pending.length && timer) { clearInterval(timer); timer = null; }
  }
  function requestPrivacy() {
    if (window.Shopify?.customerPrivacy || loadingPrivacy || typeof window.Shopify?.loadFeatures !== 'function') return;
    loadingPrivacy = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {
        loadingPrivacy = false; flush();
      });
    } catch { loadingPrivacy = false; }
  }
  function start() {
    requestPrivacy(); flush();
    if (!timer && (!configured || pending.length)) {
      ticks = 0;
      timer = setInterval(() => {
        requestPrivacy(); flush();
        if (++ticks >= 120 && timer) { clearInterval(timer); timer = null; }
      }, 500);
    }
  }
  function record(row) {
    if (!valid(row) || sent[row.id]) return false;
    if (!pending.some(item => item.id === row.id)) pending.push(row);
    pending = pending.slice(-20);
    write('sessionStorage', pendingKey, pending);
    start();
    return true;
  }
  function releasit(response) {
    const order = response?.order;
    if (!order || response.customRsiErrorMessage || order.cancelled_at || order.cancelledAt || order.test === true) return;
    const id = String(order.id || '').match(/^(?:gid:\/\/shopify\/Order\/)?(\d{5,20})$/)?.[1];
    if (!id) return;
    const sets = [order.current_total_price_set, order.total_price_set];
    let amount = null, currency = '';
    for (const kind of ['presentment_money', 'shop_money']) {
      for (const set of sets) {
        const pair = set?.[kind];
        if (money(pair?.amount) !== null && /^[A-Z]{3}$/.test(pair?.currency_code || '')) {
          amount = Number(pair.amount); currency = pair.currency_code; break;
        }
      }
      if (amount !== null) break;
    }
    if (amount === null) {
      amount = money(order.current_total_price ?? order.total_price);
      currency = order.currency_code || order.currency || '';
    }
    if (amount === null || !/^[A-Z]{3}$/.test(currency)) return;
    record({ id: 'eas_order_' + id, value: amount, currency, createdAt: Date.now() });
  }
  window.EasXTracking = Object.freeze({
    southSudanConfirmed(row) {
      if (row?.country !== 'SS' || row.currency !== 'SSP' || !/^#[A-Za-z0-9-]{1,30}$/.test(row.orderName || '')
          || !Number.isSafeInteger(row.totalMinor) || row.totalMinor <= 0) return false;
      return record({ id: 'eas_ss_' + row.orderName.slice(1), value: row.totalMinor / 100, currency: 'SSP', createdAt: Date.now() });
    }
  });
  window.addEventListener('rsi::v2::update', event => { try { releasit(event.detail?.orderResponse); } catch {} });
  document.addEventListener('visitorConsentCollected', start);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', start);
  start();
})();
